import React from 'react';
import LoadingDots from '@ott/loading-dots';
import styles from './Placeholder.scss';

const Placeholder: React.FC = () => {
  return (
    <div className={styles.Placeholder}>
      <LoadingDots />
    </div>
  );
};

export default Placeholder;
